export enum UserMenuAction {
    Logout,
    EndImpersonation,
    LanguageChangeEN,
    LanguageChangeNL,
    OpenSettings
}
